import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold">51吃瓜大赛</span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              51吃瓜大赛中心，汇聚全网最新最热门的吃瓜资讯。每日更新网红塌房、明星黑料、热门大赛，一手吃瓜资源实时放送。吃瓜，我们是认真的。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category/wanghong-tafang"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  全部分类
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/meiri-dasai"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  每日大赛
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-video-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-live-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 51吃瓜大赛 版权所有 | 本站内容仅供娱乐，请勿当真
          </p>
          <div className="flex gap-4 text-xs text-background-50/40">
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}